<mat-spinner *ngIf="isLoadingTasks" [diameter]="11" strokeWidth="1"></mat-spinner>

<span *ngIf="!isLoadingTasks && !utilService.isNullOrUndefined(taskList)">
	<span
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		[mtxPopoverTriggerFor]="taskPopover"
		class="cursor-pointer"
		mtxPopoverTriggerOn="click"
	>
		<span *ngIf="taskList.length > 0" class="dropdown" fxLayoutAlign="center center">
			{{ taskList.length }} Task{{ taskList.length > 1 ? 's' : '' }}
			<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">list</mat-icon>
		</span>
		<span *ngIf="taskList.length == 0" class="dropdown" fxLayoutAlign="center center">
			<span class="text-underline primary-text">Add Task</span>
			<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">keyboard_arrow_down</mat-icon>
		</span>
	</span>

	<mtx-popover #taskPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="task-dropdown-border" id="tasksPopover">
			<mat-card-content
				[ngClass]="{ 'w-16': taskList.length > 0, 'w-6': taskList.length == 0 }"
				class="task-dropdown"
			>
				<div class="padding-0-5" fxLayout="row">
					<app-task
						(newAddedTask)="taskAdded($event)"
						[addTask]="true"
						[carrierDTO]="carrier"
						[displayAddLink]="true"
						[projectDTO]="project"
						fxFlex
						fxLayoutAlign="center center"
					></app-task>
					<button
						*ngIf="taskList.length > 0"
						[disabled]="selection.isEmpty()"
						[matMenuTriggerFor]="taskStatuses"
						[ngClass]="{ 'task-dropdown-border': !selection.isEmpty() }"
						class="update-status-btn"
						color="primary-light-color"
						fxFlex
						mat-raised-button
					>
						Update Status
						<mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<mat-menu #menu="matMenu" xPosition="before">
						<mat-menu #taskStatuses="matMenu">
							<button
								(click)="updateStatus(taskStatus.value)"
								*ngFor="let taskStatus of taskStatusList"
								mat-menu-item
							>
								{{ taskStatus.label }}
							</button>
						</mat-menu>
					</mat-menu>
				</div>
				<table [dataSource]="dataSource" class="mat-elevation-z1 full-width" mat-table>
					<ng-container matColumnDef="select">
						<td *matCellDef="let row" mat-cell>
							<mat-checkbox
								(change)="$event ? selection.toggle(row) : null"
								(click)="$event.stopPropagation()"
								[checked]="selection.isSelected(row)"
								[color]="'primary'"
							>
							</mat-checkbox>
						</td>
					</ng-container>
					<ng-container matColumnDef="title">
						<td *matCellDef="let element" mat-cell>
							{{ element.title }}
						</td>
					</ng-container>
					<ng-container matColumnDef="status">
						<td *matCellDef="let element" mat-cell>
							{{ element.status }}
						</td>
					</ng-container>
					<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
				</table>
			</mat-card-content>
		</mat-card>
	</mtx-popover>
</span>
